import * as actionTypes from "../ActionTypes";

// ✅ Fetch Team
export const fetchTeamRequest = (payload, callback) => ({
  type: actionTypes.FETCH_TEAM_REQUEST,
  payload,
  callback,
});

export const fetchTeamSuccess = (data) => ({
  type: actionTypes.FETCH_TEAM_SUCCESS,
  payload: data,
});

export const fetchTeamFailure = (error) => ({
  type: actionTypes.FETCH_TEAM_FAILURE,
  payload: error,
});

// ✅ Save Team
export const saveTeamRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.SAVE_TEAM_REQUEST,
  payload: { apiPayloadRequest, callback },
});


export const saveTeamSuccess = (data) => ({
  type: actionTypes.SAVE_TEAM_SUCCESS,
  payload: data,
});

export const saveTeamFailure = (error) => ({
  type: actionTypes.SAVE_TEAM_FAILURE,
  payload: error,
});

// ✅ Update Team
// ✅ Unified with new saga structure
export const updateTeamRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.UPDATE_TEAM_REQUEST,
  payload: { apiPayloadRequest, callback },
});


export const updateTeamSuccess = (data) => ({
  type: actionTypes.UPDATE_TEAM_SUCCESS,
  payload: data,
});

export const updateTeamFailure = (error) => ({
  type: actionTypes.UPDATE_TEAM_FAILURE,
  payload: error,
});

// ✅ Delete Team
export const deleteTeamRequest = (payload, callback) => ({
  type: actionTypes.DELETE_TEAM_REQUEST,
  payload,
  callback,
});

export const deleteTeamSuccess = (data) => ({
  type: actionTypes.DELETE_TEAM_SUCCESS,
  payload: data,
});

export const deleteTeamFailure = (error) => ({
  type: actionTypes.DELETE_TEAM_FAILURE,
  payload: error,
});
